import { graphql, httpClient, resolveApiUrl } from '#shared/api'
import GetBalanceResponse from '../model/get-balance-response'

export default async function getBalance(
  userId: string,
  transactionsAfter: string | undefined = undefined,
  count = 20
) {
  const response = await httpClient.post<GetBalanceResponse>(resolveApiUrl('@sd-balance'), {
    json: graphql(
      `
        query ($count: Int!, $transactionsAfter: String) {
          balanceByUserId(userId: "${userId}") {
            transactions(first: $count, after: $transactionsAfter, order: DESC, sort: ["createdAt"]) {
              edges {
                cursor
                node {
                  id
                  amount
                  status
                  type
                  createdAt
                }
              }
              pageInfo {
                endCursor
                startCursor
              }
            }
            amount
          }
        }
      `,
      {
        transactionsAfter,
        count,
      }
    ),
  })

  const responseBody = await response.json()
  return responseBody.data.balanceByUserId
}
